// extracted by mini-css-extract-plugin
export var bodyRow = "_e4-d";
export var cardColumns = "_e4-e";
export var ellipsesOverflow = "_e4-2";
export var flatBottomCorners = "_e4-3";
export var flatTopCorners = "_e4-4";
export var headerActionsDropdown = "_e4-f";
export var headerBottomRow = "_e4-c";
export var headerTopRow = "_e4-b";
export var orderDetailsWrapper = "_e4-0";
export var orderInfoContainer = "_e4-1";
export var productDetails = "_e4-9";
export var productImage = "_e4-5";
export var responsiveTable = "_e4-8";
export var shipmentContainer = "_e4-a";
export var tableBottomLeft = "_e4-6";
export var tableBottomRight = "_e4-7";
export var trackingLink = "_e4-g";